import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";
const FeeTyoe = "/api/business/feeType";
const CheckDuplicateCpn = "/api/business/check-duplicate-company";
const DoctypeListCreate = "/api/business/doc-type-list";
const DoctypeList = "/api/business/doc-type-for-eform-list";
//danh sách
const getListEform = "/api/business/eform-list";
export default class FromElectronicService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public AllFeetype(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(FeeTyoe, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // lấy huyện theo tỉnh
  public getDistrictByProvince(params: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/address-district` + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // lấy xã  theo tỉnh
  public getCommunueByDistrict(params: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/address-communes` + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllDistrict(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/district-code`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllDepartment(params: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/address-list` + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAddDepartment(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/tax-department`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // chi tiết biểu mẫu
  public getDetail(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/eform?id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  //delete
  public addresDelete(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`/api/business/address-delete?` + this.convertObjectParamToStrings.convertObjectParamToStrings(query))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Khóa
  public addresLook(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/address-lock?` + this.convertObjectParamToStrings.convertObjectParamToStrings(query))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Get all Thành phố
  public getProvince(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/province`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Create dia danh
  public createAddress(queryForm?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/address-create`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //update dia danh
  public updateAddress(queryForm?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/address-edit`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
